import React from 'react'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Experience from './components/experience/Experience'
import Services from './components/services/Services'
import Internships from './components/internships/Internships'
import Playlists from './components/playlists/playlists'
import Shorts from './components/shorts/shorts'
import Upcoming from './components/upcoming/upcoming'
import Testimonials from './components/testimonials/Testimonials'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'

const App = () => {
  return (
    <>
        <Header/>
        <Nav/>
        <About/>
        {/* <Experience/>
        <Services/>
        <Internships/> */}
        <Playlists/>
        <Testimonials/>
        <Shorts/>
        <Upcoming/>
        <Contact/>
        <Footer/>
    </>
  )
}

export default App